// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_module-authorization_authorization_module_ts":"24a8dc24c5225637","src_app_module-administrator_administrator_module_ts":"254b362cd366c347"}[chunkId] + ".js";
};